export const unreadCountOfAlerts = (unreadCount = null, action) => {
    if (action.type === "FETCH_UNREAD_COUNT_OF_ALERTS") {
        return action.payload;
    }
    return unreadCount;
};